import { Component } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { TravelerDetailComponent } from '@bhtp-client-web/component';

@Component({
    selector: 'additional-traveler-detail',
    template: require('./additional-traveler-detail.component.html')
})
export class AdditionalTravelerDetailComponent extends TravelerDetailComponent {
    constructor(formBuilder: FormBuilder) {
        super(formBuilder);
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/typescript/purchase/traveler/additional-traveler-detail.component.ts